module.exports = __webpack_public_path__ + "img/contact9.2b1c8cb7.png";